import { useQuery } from "@tanstack/react-query";
import { GetActivityLogs } from "../Api/activity_log_api";
import { unwrapApiResponse } from "./query_helpers";
import { DEFAULT_STALE_TIME } from "../Constant/AppConstants";

export const useActivityLogsQuery = (params: {
  page: number;
  limit: number;
  search?: string;
  tenant_id?: string;
  method?: string;
  status_code?: string;
  section?: string;
  username?: string;
  start_date?: string;
  end_date?: string;
}) =>
  useQuery({
    queryKey: ["activity-logs", params],
    queryFn: async () => unwrapApiResponse(await GetActivityLogs(params)),
    staleTime: DEFAULT_STALE_TIME,
  });
